// Bloc du tableau de bord : encaissé du mois, impayés, quittances et actions en attente.
import { Link } from "react-router";
import { useGet } from "@core/hooks";
import { money } from "@core/format";
import { Card, Loading, Notice } from "@core/ui";
import { gApi } from "./shared";

type Dash = {
  month_label: string;
  received_cents: number;
  expected_cents: number;
  paid_for_month_cents: number;
  overdue_cents: number;
  overdue_leases: number;
  receipts_to_issue: number;
  receipts_to_send: number;
  reminders_to_validate: number;
  transactions_to_match: number;
  insurance_to_follow: number;
  active_leases: number;
  calls_missing: number;
  bank_issue: boolean;
};

export function Dashboard({ orgId }: { orgId: string }) {
  const q = useGet<Dash>(gApi(orgId, "/dashboard"));
  const to = (p: string) => `/espace/${orgId}/${p}`;
  if (q.isLoading) return <Card title="Loyers">{<Loading />}</Card>;
  if (!q.data) return null;
  const d = q.data;
  const todo: [number, string, string][] = [
    [d.calls_missing, "bail(s) sans échéance ce mois-ci", "loyers"],
    [d.transactions_to_match, "opération(s) bancaire(s) à rapprocher", "gestion/paiements"],
    [d.receipts_to_issue, "quittance(s) à établir", "gestion/quittances"],
    [d.receipts_to_send, "quittance(s) à envoyer (accord donné)", "gestion/quittances"],
    [d.reminders_to_validate, "relance(s) à valider", "gestion/relances"],
    [d.insurance_to_follow, "attestation(s) d’assurance à suivre", "gestion/relances?onglet=assurances"],
  ];
  return (
    <Card title={`Loyers — ${d.month_label}`}>
      <div className="stats">
        <div className="stat">
          <span className="stat-label">Encaissé ce mois-ci</span>
          <span className="stat-value">{money(d.received_cents)}</span>
          <span className="stat-hint">sur {money(d.expected_cents)} appelés</span>
        </div>
        <div className="stat">
          <span className="stat-label">Impayés échus</span>
          <span className="stat-value">{money(d.overdue_cents)}</span>
          <span className="stat-hint">Baux concernés : {d.overdue_leases}</span>
        </div>
      </div>
      {d.bank_issue ? (
        <Notice tone="attention">
          Synchronisation bancaire en retard ou à renouveler : <Link to={to("gestion/banque")}>vérifier la banque</Link>. Les relances attendent.
        </Notice>
      ) : null}
      <ul className="gestion-list">
        {todo
          .filter(([n]) => n > 0)
          .map(([n, label, path]) => (
            <li key={label}>
              <Link to={to(path)}>
                {n} {label}
              </Link>
            </li>
          ))}
        {todo.every(([n]) => n === 0) ? <li className="muted">Rien à traiter pour les loyers.</li> : null}
      </ul>
    </Card>
  );
}
